"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function queueStageLayout(layout) {
  return (0, _utils.actionCreator)(_types.BROADCAST_QUEUE_STAGE_LAYOUT, layout);
}
var _default = exports["default"] = queueStageLayout;